import "./index.css";
import Header from "./layouts/Header/Header";
import Sidebar from "./layouts/Sidebar/Sidebar";
import PublicRoutes from "./layouts/Routers/PublicRoutes";
import Cookies from "js-cookie";
import AppRouters from "./layouts/Routers/Routers";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import authActions from "./redux/auth/actions";
import { useLocation } from "react-router-dom";
import InactivityLogout from "./utils/InactiveLogout";
import { onLoginSuccess } from "./socket";

function App() {
  const token = sessionStorage.getItem("biller_access");

  const { getProfile } = authActions;
  const dispatch = useDispatch();
  const location = useLocation();

  // Prevent embedding in an iframe
  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(getProfile());
    }
  }, [location.pathname]);

  useEffect(() => {
    if (token) {
      onLoginSuccess(token, dispatch);
    }
  }, [token, dispatch]);

  return (
    <div className="App">
      {token ? (
        <>
          <Header />
          <div className="partDashboard">
            <Sidebar />
            <AppRouters />
          </div>
          <InactivityLogout />
        </>
      ) : (
        <div>
          <PublicRoutes />
        </div>
      )}
    </div>
  );
}

export default App;
